module.exports = __webpack_public_path__ + "static/media/mx.e3a44617.svg";